import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconStarred$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStarred extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a6ef323f82d5af6145de4d6aea9db8535ba8e0ca', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1d5a4716d53623d5411fdd9a273a617c60b83d4c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '57bcca7e23676f3860f5a621c1e0a610ba2e26d8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 3a.5.5 0 0 0-.5.5v15.6a.4.4 0 0 0 .669.3L11 14.557l5.332 4.836A.4.4 0 0 0 17 19.1V3.5a.5.5 0 0 0-.5-.5zm10 13.614-4.16-3.778a.5.5 0 0 0-.672 0L6.5 16.614V4.5h9zm-3.13-7.417 1.455-1.237c.208-.173.175-.335-.116-.367l-1.838-.157-.66-1.74c-.113-.261-.373-.261-.473 0l-.64 1.719-1.86.167c-.23.011-.34.2-.112.378l1.468 1.225-.527 1.771c-.083.273 0 .378.289.22l1.614-1.057 1.637 1.058c.239.157.373.052.29-.22z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-starred", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-starred"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-starred":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStarred$1);
            }
            break;
    } });
}

const CosmosIconStarred = CosmosIconStarred$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStarred, defineCustomElement };
